<template>
    <div class="container mt-5">
        <h2>Editar Usuario</h2>

        <form @submit.prevent="updateUser" class="row mt-5">
            <!-- Nombre -->
            <div class="mb-3 col-12 col-md-6">
                <label class="form-label">Nombre</label>
                <input type="text" v-model="form.name" class="form-control" required>
            </div>

            <!-- Email -->
            <div class="mb-3 col-12 col-md-6">
                <label class="form-label">Correo</label>
                <input type="email" v-model="form.email" class="form-control" required>
            </div>

            <!-- Password -->
            <div class="mb-3 col-12 mt-3">
                <label class="form-label">Contraseña</label>
                <input type="password" v-model="form.password" class="form-control"
                    placeholder="Nueva contraseña (dejar en blanco para no cambiar)">
            </div>

            <!-- Rol -->
            <!-- <div class="mb-3">
                <label class="form-label">Rol</label>
                <select v-model="form.role" class="form-select" required>
                    <option value="admin">Administrador</option>
                    <option value="user">Usuario</option>
                    <option value="guest">Invitado</option>
                </select>
            </div> -->
            <div class="col-12 row justify-content-center mt-3" style="left: 4%;" v-if="buttonShow">
                <div class="col-6 col-md-4">
                    <button type="submit" class="btn btn-info text-light">Guardar cambios</button>
                </div>

            </div>

        </form>
    </div>
</template>
<script>
import axios from "axios"
const token = localStorage.getItem("token")
export default {
    name: "PorfileDash",
    data() {
        return {
            id: null,
            form: {
                name: "Cargando...",
                email: "Cargando...",
                password: "",
                role: "admin",
                buttonShow: false
            }
        }
    },
    methods: {
        async getDataUserEdit() {
            
            try {
                const response = await axios.get("https://beauvoyage.net/api/v1/auth/me", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                this.id = response.data.id;
                this.form.name = response.data.name;
                this.form.email = response.data.email;
                this.buttonShow = true;

            } catch (error) {
                localStorage.removeItem("token")
                this.$router.push("/login")
            }
        },
        async updateUser() {
    try {
        const token = localStorage.getItem("token")

        // Evitar enviar password vacío si no se quiere actualizar
        if (!this.form.password) {
            delete this.form.password
        }

        await axios.put(
            `https://beauvoyage.net/api/v1/auth/users/${this.id}`,
            this.form,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )

        alert("Usuario actualizado con éxito ✅")
    } catch (error) {
        console.error("Error al actualizar usuario:", error.response?.data || error)
        alert("No se pudo actualizar el usuario ❌")
    }
}
    },
    created() {
        this.getDataUserEdit()
    }
};
</script>